import React from "react";
import { OAuthListWrapper } from "./style.jsx";
import localeService from "../../../service/localeService.js";
import { isChannelKeyEffect } from "../../../common/channel.js"


const OAuthBJCA = ({  bindChange }) => {
    // 和 UCloud 或 UCloud Global 域名相同的渠道入口不显示第三方注册
    if(isChannelKeyEffect()){
        return null;
    }

    return (
        <OAuthListWrapper>
            <div className='oauth-login-btn u-mb4' onClick={() => bindChange()} style={{width: 400}}>
                <img className='btn-logo' src="https://cdn.udelivrs.com/2025/05/262fb2dcf3632c8decb60bd36b92de20_1747984014172.png" />
                <span className='btn-text'>
                    {localeService.getTranslate("LOGINBYBJCA")}
                </span>
            </div>
        </OAuthListWrapper>
    );
};

export default OAuthBJCA;



// WEBPACK FOOTER //
// src/pc/components/ThirdPartyOAuth/OAuthBjca.jsx